export const darkenedColor = (rgba: string, darkenAmount: number): string => {
  // 限制 darkenAmount 在 0 到 10 的范围内
  darkenAmount = Math.max(0, Math.min(10, darkenAmount));

  // 非线性变暗处理，使用平方关系，使得变暗程度更符合人眼的感知
  const adjustedDarkenAmount = Math.pow(darkenAmount / 10, 2);

  // 正则表达式解析 rgba 字符串，提取 r, g, b, a 值
  const rgbaMatch = rgba.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);

  if (!rgbaMatch) {
    throw new Error("Invalid RGBA format");
  }

  // 提取 r, g, b, a 值并转为整数/浮点数
  let r = parseInt(rgbaMatch[1]);
  let g = parseInt(rgbaMatch[2]);
  let b = parseInt(rgbaMatch[3]);
  const a = parseFloat(rgbaMatch[4]);

  // 计算每个颜色通道的变暗比例 (10 代表完全变为黑色)
  // 使用非线性变暗处理，颜色越接近 0 越暗，符合人眼对亮度的感知
  r = Math.round(r * (1 - adjustedDarkenAmount));
  g = Math.round(g * (1 - adjustedDarkenAmount));
  b = Math.round(b * (1 - adjustedDarkenAmount));

  // 返回新的 rgba 字符串
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

export const getRoleLevelColor = (level: number) => {
  switch (level) {
    case 6:
      return "rgba(242, 196, 37, 1)";
    case 5:
      return "rgba(227, 99, 99, 1)";
    case 4:
      return "rgba(145, 83, 218, 1)";
    case 3:
      return "rgba(99, 141, 227, 1)";
    case 2:
      return "rgba(89, 233, 185, 1)";
    case 1:
      return "rgba(154, 245, 144, 1)";
  }
  return "rgba(0, 0, 0, 1)";
};

export const getStatusColor = (id: number) => {
  if (id === 1) return "rgba(0, 255, 0, 1)";
  return "rgb(129, 129, 129)";
};
